import { authApi } from '../utils/api';

export const myRuhsatlarPage = () => {
    const user = authApi.getCurrentUser();

    if (!user) {
        return `
            <section class="page-content">
                <div class="container">
                    <div class="alert alert-warning">
                        <p>Bu sayfayı görüntülemek için giriş yapmanız gerekiyor.</p>
                        <a href="/giris" class="btn-primary">Giriş Yap</a>
                    </div>
                </div>
            </section>
        `;
    }

    return `
        <section class="page-content">
            <div class="container">
                <div class="page-header">
                    <h1 class="page-title">Ruhsatlarım</h1>
                    <a href="/hesabim" class="btn-outline">← Panele Dön</a>
                </div>

                <div id="ruhsatlarList" class="data-list">
                    <div class="loading">Yükleniyor...</div>
                </div>
            </div>
        </section>
    `;
};
